import { Component, Vue, Watch } from 'vue-property-decorator';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { documentCard } from '@/shared/model/document-card.model';
import { namespace } from 'vuex-class';
import RefCardItem from '@/shared/cards/briefing/ref-card-item/ref-card-item.vue';
import { formatDate } from '@/util/date-util';
import { removeUnUsedSpace } from '@/util/string.util';

const briefingStore = namespace('briefingStore');

@Component({
  methods: { removeUnUsedSpace },
  components: {
    'ref-item': RefCardItem,
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class RefNoteComponent extends Vue {
  @briefingStore.Getter
  getAddingReferenceDocuments!: Array<any>;

  @briefingStore.Mutation
  public setAddingReferenceDocuments!: (payload: any) => void;

  item = new documentCard();
  allItem = [];
  selectedItems = [];
  scrollSettings = {
    wheelPropagation: false,
  };
  totalSelected = 0;
  currentDate = formatDate(new Date());

  @Watch('getAddingReferenceDocuments')
  onGetAddingReferenceDocumentsChanged() {
    if (this.selectedItems && this.getAddingReferenceDocuments) {
      this.selectedItems = this.selectedItems.filter(selectedItem => {
        return this.getAddingReferenceDocuments.some(item => {
          return selectedItem === item;
        });
      });
    }
  }

  addToArr() {
    if (this.item.content && this.item.title) {
      const tempContent = removeUnUsedSpace(this.item.content);
      const tempTitle = removeUnUsedSpace(this.item.title);
      if (tempContent?.length > 99 && tempTitle) {
        this.item.content = tempContent;
        this.item.title = tempTitle;
        const obj = this.allItem.find(element => element.content == tempContent && element.title == tempTitle);
        if (obj) return;
        this.item.author = '';
        this.item.keyword = '';
        this.item.type = 'USERNOTE';
        this.item.searchType = 'USERNOTE';
        this.item.addedAt = new Date().toISOString();
        this.item.create_date = new Date().toISOString();
        this.item.url = '';
        this.item.collector = 'UW';
        this.item.favicon = '';
        this.item.typeRemove = 'text';
        this.item.channel = 'Note';
        this.item.image_uri = [''];
        this.item.image_uri_thumbnail = '';
        this.item.published_at = new Date().toISOString();
        this.item.service_html = '';
        this.item.forcedClustering = false;
        this.item.path = '';
        this.item.description = '';
        // this.item.lang = this.getLanguage();
        this.item.lang = '';
        this.item.originDate = '';
        this.item.parentDocId = '';
        this.item.docId = '';
        this.item.mediaType = ['USERNOTE'];
        this.item.docType = 1;
        this.item.isInsideGroup = false;
        this.item.isGroup = false;
        // this.item.userKey = this.getUserKey();
        this.item.userKey = '';
        this.item.targetBpId = '';

        const itemPush = Object.assign(new documentCard(), this.item);
        // console.log('itemPush: ', itemPush);
        this.allItem.push(itemPush);
        this.selectedItems.push(itemPush);
        this.item = new documentCard();
        this.setAddingReferenceDocuments([...(this.getAddingReferenceDocuments ? this.getAddingReferenceDocuments : []), itemPush]);
      }
    }
  }

  removeCardReq(item) {
    const index = this.selectedItems.indexOf(item);
    if (index !== -1) this.selectedItems.splice(index, 1);
  }

  selectAddingReferenceDocument(item) {
    let index = -1;

    if (this.selectedItems !== null && this.selectedItems.length > 0) {
      index = this.selectedItems.indexOf(item);
    }

    if (index !== -1) {
      this.selectedItems.splice(index, 1);
      this.removeReferenceDocument(item);
    } else {
      this.selectedItems.push(item);
      this.setAddingReferenceDocuments([...(this.getAddingReferenceDocuments ? this.getAddingReferenceDocuments : []), item]);
    }
  }

  removeCardInList(item) {
    const index = this.allItem.indexOf(item);
    if (index !== -1) this.allItem.splice(index, 1);
    this.removeCardReq(item);
    this.removeReferenceDocument(item);
  }

  removeReferenceDocument(item) {
    if (this.getAddingReferenceDocuments !== null && this.getAddingReferenceDocuments.length > 0) {
      const index = this.getAddingReferenceDocuments.indexOf(item);

      if (index !== -1) {
        this.getAddingReferenceDocuments.splice(index, 1);
        this.setAddingReferenceDocuments(this.getAddingReferenceDocuments);
      }
    }
  }
}
